import WithRoutify from "../../../hoc/WithRoutify";
import { formatPhoneNumberUS, isSet } from "../../../utils/commonUtils";
import Icons from "../../../components/UI/Icons";
import { useState } from "react";
const newCompanyDetails = (props) => {
//   const [viewModelOpen,setViewModelOpen]=useState(false);
  const {companyDetails}=props;
  const inputFields = [
    {
      label: "Name",
      name: "name",
      value:companyDetails?.name, 
    },
    {
      label: "Phone",
      name: "name",
      value: formatPhoneNumberUS(companyDetails?.phone), 
    },
    {
      label: "Email",
      name: "name",
      value:companyDetails?.general_email, 
    },
    // {
    //   label: "Results to Employee ",
    //   name: "name",
    //   value:companyDetails?.send_physical_results_to_employees?"Yes":"No", 
    // },
  ];
//  ` const viewCompanyDetails=()=>{
//     setViewModelOpen(!viewModelOpen);
//   }`
  return (
    <>
    {/* { 
      viewModelOpen?
      <EmployeeDetails
      employeeId={props.employeeId}
      modalToogleHandler={viewPatientDetails}
      fetchEmployeeList={()=>props.fetchEmployeeDetails(employeeId)}
      />
      :
      ''
    } */}
      <div className="sh_cardBox mb-3 h-auto sh_cardbglight">
        <div className="sh_cardHeader p-2">
          <div className="d-flex align-items-center justify-content-between">
            <h6 className="text-md font-weight-bold mb-0">
            {/* <span className="px-2">
              <Icons type="companydetails" />
            </span> */}
              Company Details</h6>
            {/* <Buttons
            className=" text-xs text-info"
            label={" View More"}
            acl={'any'}
            clickHandler={viewCompanyDetails}
            /> */}
          </div>
        </div>
        <div className="sh_cardBody py-0">
                  <div className="row">
                      {inputFields.map((field, fieldInd) => (
                          <>
                              <div class="col-6 pt-2" key={fieldInd}>
                                  <label class="f-400 text-sm text-truncate mb-0 opacity-75">{field.label}</label></div>
                              <div class="col-6 pt-2">
                                  <h6 class="font-weight-bold text-sm text-right text-truncate mb-0" title={field.value}>{isSet(field.value, '--')}</h6>
                              </div>
                          </>
                      ))}
          </div>
        </div>
      </div>
    </>
  );
};
export default WithRoutify(newCompanyDetails);
